// Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white text-center py-4">
      <p>&copy; 2024 Online Judge. All rights reserved.</p>
      <p>Made by Yash Choudhary</p>
    </footer>
  );
};

export default Footer;
